var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 198,
    height: 161,
    viewBox: "0 0 198 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M133.396 46.6071C119.336 46.6071 105.041 46.0553 91.6541 42.3431C78.267 38.6309 66.5281 31.6914 55.7311 23.5647C48.6844 18.2639 42.2768 14.0668 33.1446 14.7022C24.2097 15.1708 15.6644 18.4897 8.77553 24.1666C-2.84563 34.1996 -1.07975 52.9781 3.56199 66.138C10.5414 85.9532 31.7992 99.7151 49.8616 108.695C70.7326 119.062 93.5881 125.082 116.645 128.543C136.827 131.587 162.676 133.794 180.133 120.717C196.177 108.695 200.583 81.2544 196.648 62.7101C195.695 57.2347 192.765 52.2935 188.407 48.8144C177.139 40.6375 160.338 46.1055 147.674 46.373C142.965 46.4733 138.139 46.5904 133.396 46.6071Z",
    fill: "#F2F2F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M177.576 87.8595V95.0498",
    stroke: "#BABABA",
    strokeWidth: 1.68179,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M173.961 91.4546H181.192",
    stroke: "#BABABA",
    strokeWidth: 1.68179,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0554 47.0586V54.2489",
    stroke: "#BABABA",
    strokeWidth: 1.68179,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4399 50.6538H54.6716",
    stroke: "#BABABA",
    strokeWidth: 1.68179,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M95.7912 16.5416C96.7015 16.5416 97.4394 15.8079 97.4394 14.9029C97.4394 13.9978 96.7015 13.2642 95.7912 13.2642C94.881 13.2642 94.1431 13.9978 94.1431 14.9029C94.1431 15.8079 94.881 16.5416 95.7912 16.5416Z",
    fill: "#CFCFCF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3386 9.68577C35.2488 9.68577 35.9867 8.95209 35.9867 8.04705C35.9867 7.14201 35.2488 6.40833 34.3386 6.40833C33.4283 6.40833 32.6904 7.14201 32.6904 8.04705C32.6904 8.95209 33.4283 9.68577 34.3386 9.68577Z",
    fill: "#CFCFCF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M106.05 161C140.092 161 167.688 159.293 167.688 157.188C167.688 155.082 140.092 153.375 106.05 153.375C72.0087 153.375 44.4126 155.082 44.4126 157.188C44.4126 159.293 72.0087 161 106.05 161Z",
    fill: "#F2F2F2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6718 51.239H74.2642V95.2838H80.6718V51.239Z",
    fill: "#D2D2D2"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1377 54.447L77.1902 60.0486L114.231 40.0936L111.179 34.4921L74.1377 54.447Z",
    fill: "#D2D2D2"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2127 91.4713H82.0175C87.0176 91.4713 91.8129 93.4462 95.3485 96.9616C98.8841 100.477 100.87 105.245 100.87 110.216V111.587H53.3599V110.216C53.3599 105.245 55.3461 100.477 58.8817 96.9616C62.4173 93.4462 67.2126 91.4713 72.2127 91.4713Z",
    fill: "white",
    stroke: "#BABABA",
    strokeWidth: 1.68179,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M107.345 111.805H46.8848",
    stroke: "#BABABA",
    strokeWidth: 1.68179,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8634 67.4591C84.003 67.4591 88.9801 62.5104 88.9801 56.406C88.9801 50.3016 84.003 45.353 77.8634 45.353C71.7239 45.353 66.7468 50.3016 66.7468 56.406C66.7468 62.5104 71.7239 67.4591 77.8634 67.4591Z",
    fill: "white",
    stroke: "#BABABA",
    strokeWidth: 1.68179,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M139.703 98.5279C139.417 98.4276 137.264 98.6282 136.995 98.5279C135.061 97.8089 134.371 100.2 132.589 99.2135C121.234 93.4038 112.411 83.6639 107.783 71.8308C103.154 59.9978 103.041 46.8897 107.464 34.9794C111.888 23.0691 120.542 13.1799 131.794 7.17727C143.046 1.17466 156.119 -0.526362 168.545 2.39508C170.667 2.90528 172.756 3.54186 174.802 4.30136C175.188 4.43513 174.247 6.50861 174.617 6.64239L139.703 98.5279Z",
    fill: "white",
    stroke: "#BABABA",
    strokeWidth: 1.68179,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M173.154 58.9311C165.047 80.5187 153.073 96.9394 143.369 101.153C142.07 101.762 140.666 102.12 139.232 102.207C138.147 102.279 137.058 102.125 136.037 101.755C135.232 101.458 134.486 101.022 133.833 100.468C133.465 100.173 133.126 99.8429 132.824 99.4811C126.097 91.8393 127.19 69.3821 136.188 45.3029C145.101 21.5916 158.758 4.05058 168.865 2.24464C169.49 2.11653 170.128 2.06043 170.766 2.07743C171.621 2.09554 172.468 2.25373 173.271 2.54564C174.418 2.98066 175.448 3.67309 176.282 4.56896C177.182 5.52083 177.93 6.60343 178.502 7.77951C183.026 17.2941 181.226 37.4939 173.154 58.9311Z",
    fill: "#D2D2D2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M137.18 44.2828L189.719 63.3622",
    stroke: "#BABABA",
    strokeWidth: 1.68179,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M186.692 69.1312C190.741 69.1312 194.024 65.8671 194.024 61.8406C194.024 57.8141 190.741 54.5499 186.692 54.5499C182.642 54.5499 179.359 57.8141 179.359 61.8406C179.359 65.8671 182.642 69.1312 186.692 69.1312Z",
    fill: "white",
    stroke: "#BABABA",
    strokeWidth: 1.68179,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8706 23.0631C63.8706 23.9824 63.6882 24.8926 63.3339 25.7418C62.9796 26.5909 62.4602 27.3621 61.8057 28.0114C61.1511 28.6607 60.3742 29.1752 59.5193 29.5255C58.6645 29.8757 57.7485 30.0549 56.8239 30.0527H39.552C38.2138 30.0527 36.9305 29.5242 35.9843 28.5834C35.0382 27.6426 34.5066 26.3667 34.5066 25.0362C34.5066 23.7058 35.0382 22.4298 35.9843 21.489C36.9305 20.5482 38.2138 20.0197 39.552 20.0197C40.2141 20.0207 40.8702 20.1455 41.486 20.3876C41.4183 20.0631 41.3845 19.7325 41.3851 19.401C41.397 18.0971 41.8801 16.8409 42.7462 15.8616C43.6122 14.8824 44.8035 14.2455 46.1027 14.067C47.4019 13.8886 48.7222 14.1805 49.8229 14.8896C50.9235 15.5987 51.7311 16.6776 52.0981 17.9295C53.3781 16.737 55.0698 16.0785 56.8239 16.0901C57.7471 16.0879 58.6617 16.2666 59.5154 16.6158C60.3692 16.965 61.1454 17.478 61.7997 18.1255C62.4541 18.773 62.9737 19.5423 63.3291 20.3895C63.6844 21.2367 63.8684 22.1452 63.8706 23.0631Z",
    fill: "white",
    stroke: "#BABABA",
    strokeWidth: 1.68179,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.ed6257ac9bdb4d93bd916f98cbfc4f3e.svg";
export { ForwardRef as ReactComponent };